import firebase from "firebase/compat/app";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import SaveDeviceToken from "../../ApiHandlers/SaveDeviceToken";

import newMessageNotification from "../../redux/actionCreators/newMessageNotification";
import newNonMessageNotification from "../../redux/actionCreators/newNonMessageNotification";

import { firebaseConfigration } from "./firebaseConfigration";
import projectSettings from "./projectSettings";

let notificationData = null;

const firebaseApp = initializeApp(firebaseConfigration);
export const messaging = "serviceWorker" in navigator ? getMessaging(firebaseApp):null;
export const getDeviceToken = () => {
  messaging && getToken(messaging, {
    vapidKey: projectSettings.firebaseApiKey,
  })
    .then((currentToken) => {
      if (currentToken) {
        SaveDeviceToken(currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};
